<template>
  <!-- 预览文件 -->
  <van-popup
    v-model:show="visable"
    class="popup"
    closeable
    :overlay-style="{ zIndex: 3005 }"
    position="bottom"
    round
    :style="{ height: height, zIndex: 3006 }"
  >
    <div class="title">{{ title }}</div>
    <div class="agreement-list flex" v-if="urlList.length">
      <div
        class="list-item"
        :class="{
          current: index == currentIndex,
        }"
        v-for="(item, index) in urlList"
        :key="index"
        @click="itemClick(item, index)"
      >
        {{ item.MaterialName }}
      </div>
    </div>
    <iframe
      v-if="visable && type === 'iframe'"
      border="none"
      class="content"
      :src="src"
    ></iframe>
    <div v-else class="content text-center">
      <div v-if="visable && type === 'image'" class="image-box">
        <img class="img" :src="src" />
      </div>
      <div v-if="visable && type === 'audio'" class="audio-box">
        <audio controls="controls" controlsList="nodownload" :src="src"></audio>
      </div>
      <div v-if="visable && type === 'video'" class="video-box">
        <VideoPlayer ref="video" :options="videoOption" />
      </div>
      <div v-if="visable && type === 'txt'" class="txt-box">
        <div v-html="src"></div>
      </div>
    </div>
  </van-popup>
</template>
<script>
/* eslint-disable */
import { Toast, Dialog } from "vant";
import store from "@/store";
import api from "@/api";
import { copyText } from "@/utils/index";
import VideoPlayer from "@/components/VideoPlayer";
export default {
  components: { VideoPlayer },
  data() {
    return {
      urlList: [],
      currentIndex: 0,
      visable: false,
      src: "",
      selectItem: null,
      office: ["ppt", "pptx", "doc", "docx", "xls", "xlsx"],
      iframe: ["pdf"],
      image: ["jpg", "jpeg", "gif", "bmp", "png", "svg", "webp", "ico", "jfif"],
      video: ["mp4", "m3u8", "webm"],
      audio: ["mp3", "m4a"],
      txt: ["txt"],
      title: "预览文件",
      //type = iframe 用iframe打开  video image audio
      type: "none",
      height: "92%",
      // 用于视频封面
      videoOption: null,
    };
  },
  methods: {
    itemClick(item, index) {
      this.currentIndex = index;
      const url = api.FileHost + item.MaterialUrl;
      this.switchType(url);
    },
    async readFile(row) {
      let data = row;
      this.selectItem = data;
      this.title = data.MaterialName;
      const arr = data.MaterialUrl.split(",");
      if (arr && arr.length > 1) {
        this.urlList = arr.map((item, index) => {
          return {
            MaterialName: `协议${index + 1}`,
            MaterialUrl: item,
          };
        });
        data = this.urlList[0];
        this.currentIndex = 0;
      } else {
        this.urlList = [];
      }
      // if(data.MaterialUrl)
      let url = api.FileHost + data.MaterialUrl;
      const MaterialType = data.MaterialType;
      // popup高度
      this.height = "94%";
      // 视频封面
      let poster = "";
      if (MaterialType === 10 || MaterialType === 20) {
        if (!data.Asset) {
          const asset = await this.getVod(data.AssetId);
          data.Asset = asset;
        }
        if (MaterialType === 20) {
          // 音频获取绝对地址
          url = data.Asset.BaseInfo.VideoUrl;
        } else {
          // 视频类型获取m3u8格式文件
          url = data.Asset.TranscodeInfo.Output[0].Url;
          poster = data.Asset.BaseInfo.CoverInfoArray[0].CoverUrl;
        }
      }
      this.switchType(url, poster);
    },
    async switchType(url) {
      const lastIndex = url.lastIndexOf(".");
      let suffix = (lastIndex != -1
        ? url.substring(lastIndex + 1)
        : "none"
      ).toLowerCase();
      if (this.office.includes(suffix)) {
        this.type = "iframe";
        this.src = "https://view.officeapps.live.com/op/embed.aspx?src=" + url;
        if (!this.visable) {
          this.show();
        }
        return;
      }
      if (this.iframe.includes(suffix)) {
        this.type = "iframe";
        this.src = `static/pdf/web/viewer.html?file=${url}`;
        if (!this.visable) {
          this.show();
        }
        return;
      }

      if (this.video.includes(suffix)) {
        this.type = "video";
        this.src = url;
        this.height = "40%";
        this.getOption(url, poster, suffix);
        if (!this.visable) {
          this.show();
        }
        return;
      }

      if (this.audio.includes(suffix)) {
        this.type = "audio";
        this.src = url;
        this.height = "24%";
        if (!this.visable) {
          this.show();
        }
        return;
      }

      if (this.image.includes(suffix)) {
        this.type = "image";
        this.src = url;
        if (!this.visable) {
          this.show();
        }
        return;
      }

      if (this.txt.includes(suffix)) {
        this.type = "txt";
        this.src = await this.readText(url);
        if (!this.visable) {
          this.show();
        }
        return;
      }

      this.copyUrl(url);
    },
    readText(url) {
      return new Promise((resolve, reject) => {
        url = url.replace(/\\/g, "/");
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            var reader = new FileReader(); //new一个FileReader实例
            reader.onload = function () {
              const text = this.result.replace(/\n/g, "<br/>");
              resolve(text);
            };
            reader.readAsText(xhr.response, "utf-8");
          }
        };

        xhr.send();
      });
    },
    getOption(src, poster, suffix) {
      console.log(poster);
      let type = "";
      if (suffix === "m3u8") {
        type = "application/x-mpegURL";
      }
      if (suffix === "mp4") {
        type = "video/mp4";
      }
      if (suffix === "webm") {
        type = "video/webm";
      }
      this.videoOption = {
        autoplay: false,
        language: "zh-CN",
        controls: true,
        fluid: false,
        //preferFullWindow: true,
        playsinline: true,
        metadataTrack: false,
        playbackRates: [0.5, 1.0, 1.25, 1.5, 2.0],
        poster: poster,
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true, //视频时长时间显示
          remainingTimeDisplay: false, //剩余时间显示
          fullscreenToggle: true, // 全屏按钮
        },
        // errorDisplay: false, //错误显示
        bigPlayButton: true, //视频中间的播放按钮显示
        sources: [
          {
            src,
            type,
          },
        ],
      };
    },
    copyUrl(url) {
      Dialog.alert({
        title: "请复制链接至浏览器下载",
        message: url,
        confirmButtonText: "复制",
      }).then(() => {
        copyText(url);
      });
    },
    show() {
      this.visable = true;
      //this.src = url
    },
    // 获取vod detail
    async getVod(id) {
      const loading = Toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true,
      });
      return new Promise((resolve, reject) => {
        store
          .dispatch("service/ShowAssetDetail", {
            AssetId: id,
          })
          .then((data) => {
            resolve(data.Data);
            loading.clear();
          })
          .catch((e) => {
            reject(e);
            loading.clear();
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.popup {
  background: #999;
}
.title {
  height: 56px;
  line-height: 56px;
  padding-left: 16px;
  padding-right: 40px;
  background: #f1f1f1;
  overflow: hidden;
}
.content {
  border: none;
  width: 100%;
  padding: 0;
  height: calc(100% - 56px);
  overflow-x: hidden;
  overflow-y: auto;
}
.image-box {
  height: 100%;
  .img {
    width: 100%;
  }
}
.audio-box {
  padding-top: 30px;
}
.video-box {
  padding: 10px;
}
.txt-box {
  padding: 0 10px;
}
.agreement-list {
  height: 25px;
  padding: 5px 10px 10px 10px;
  // box-sizing: border-box;
  overflow-y: auto;
}
.list-item {
  white-space: nowrap;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  margin-right: 20px;
  position: relative;
  &.current::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translateX(-50%);
    width: 60%;
    height: 2px;
    background: rgb(255, 98, 41);
  }
}
</style>
